<template>
  <section class="iorder-menu-legacy">
    <sticky-banner v-bind="props" />
    <div v-if="isLoading" class="iorder-menu-legacy__loading">
      <span class="sr-only" role="alert" aria-live="assertive">
        {{ $t('iorder-content-loading') }}
      </span>
      <loading-placeholder :items-number="placeholderItems" modifier-name="iorder" />
    </div>
    <i-order-menu-main
      :fields="fields"
      :params="params"
      :i-order-menu-rendering="rendering"
      :is-loading="isLoading"
      @set-is-loading="setIsLoading"
    />
  </section>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent, computed, onMounted, onBeforeUnmount } from 'vue';
import StickyBanner from './StickyBanner/StickyBanner.vue';
import LoadingPlaceholder from '../2_elements/LoadingPlaceholder/LoadingPlaceholder.vue';
import useMedia from '../../utils/useMedia';
import { useAppStore } from '../../stores/appStore';
import type { IOrderMenuLegacyProps } from './types';

const IOrderMenuMain = defineAsyncComponent(
  () => import(/* webpackChunkName: "IOrderMenuMain" */ './IOrderMenuMain.vue')
);

const appStore = useAppStore();

const props = withDefaults(defineProps<IOrderMenuLegacyProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const isLoading = ref(true);
const { isMedia: isTablet } = useMedia('(min-width: 768px)');
const { isMedia: isDesktop } = useMedia('(min-width: 1024px)');

const placeholderItems = computed<number>(() => {
  if (isDesktop.value) return 9;
  return isTablet.value ? 8 : 3;
});

const setIsLoading = (val: boolean): void => {
  isLoading.value = val;
};

onBeforeUnmount(() => {
  appStore.disableSmoothScroll(false);
});

onMounted(() => {
  appStore.disableSmoothScroll(true);
});
</script>

<style lang="scss">
@import './scss/IOrderMenu.scss';
</style>
